import { Severity } from '@app/Types/Sentry';
import { seoDataType } from '@entities/Seo/module/types/seoSchema';
import * as Sentry from '@sentry/browser';

export const sendSentrySeoInfo = async (url: string, data: seoDataType, prefix: string = 'server') => {
  try {
    if (!data.title) {
      Sentry.captureMessage(`${prefix}-seo-wrapper: ${url}`, {
        level: Severity.Info,
        extra: {
          timestamp: new Date().toISOString(),
          dataResponse: data,
        },
      });
    }
  } catch (error) {
    console.log(error);
  }
};
